// Polyfills - need to be removed once polyfills.js is created
// trim() polyfill for IE8-
if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}